import React from 'react';
import { BlurredContainerM3030 } from '../../../../components/containers/containers';
import MyAreaChart from '../../../../components/data-viewers/charts/area-chart/area-chart';
import StyledReactSelect from '../../../../components/inputs/styled-react-select';
import { formatNumber } from '../../../../helpers/number-formatters';
import { HistoryGraph } from '../../../../logic/graphql/types/types';
import { Percentage } from './components';
import CenteredSpinner from '../../../../components/loading-indicators/centered-spinner';
import styled from 'styled-components';
import { withErrorBoundary } from '@sentry/react';
import { Fallback } from '../../../../components/utils/error-boundary';
import { FormattedMessage, useIntl } from 'react-intl';

const ValueLabel = styled.span`
  font-size: 14px;
  @media (min-width: 1280px) {
    font-size: 18px;
  }
`;

const TitleCol = styled.div`
  @media (max-width: 1280px) {
    max-width: 160px;
  }
`;

const History = (props: {
  data?: HistoryGraph;
  account?: string;
  onChangeInterval: (interval: number) => void;
  loading?: boolean;
}): JSX.Element => {
  const intl = useIntl();
  if (props.loading) {
    return (
      <BlurredContainerM3030 className="w-1/1 mb-6 flex flex-col">
        <CenteredSpinner />
      </BlurredContainerM3030>
    );
  }

  return (
    <BlurredContainerM3030 className="w-1/1 mb-6 flex flex-col">
      <div className="w-1/1 flex flex-row justify-between mb-2">
        <TitleCol className="flex flex-col">
          <h3 className="mb-3">
            <FormattedMessage id={'dashboardPage.history.title'} />
          </h3>
          <StyledReactSelect
            onChange={(value) => props.onChangeInterval(value as number)}
            placeholder={intl.formatMessage({
              id: 'dashboardPage.history.intervalSelect.placeholder',
            })}
            defaultValue={{
              value: 1,
              label: intl.formatMessage({ id: 'dashboardPage.history.intervalSelect.options.1' }),
            }}
            options={[
              {
                value: 1,
                label: intl.formatMessage({ id: 'dashboardPage.history.intervalSelect.options.1' }),
              },
              {
                value: 3,
                label: intl.formatMessage({ id: 'dashboardPage.history.intervalSelect.options.3' }),
              },
              {
                value: 6,
                label: intl.formatMessage({ id: 'dashboardPage.history.intervalSelect.options.6' }),
              },
              {
                value: 12,
                label: intl.formatMessage({ id: 'dashboardPage.history.intervalSelect.options.12' }),
              },
              {
                value: 0,
                label: intl.formatMessage({ id: 'dashboardPage.history.intervalSelect.options.0' }),
              },
            ]}
            type="thin-ice"
          />
        </TitleCol>
        <div className="flex flex-col items-end">
          <ValueLabel className="text-18 mb-1 text-right">
            <b>{formatNumber(props.data?.value)}</b> HUF
          </ValueLabel>
          {props.data ? (
            <Percentage isPositive={props.data.percent >= 0}>
              {props.data.percent >= 0 ? '+' : ''}
              {props.data.percent}%
            </Percentage>
          ) : null}
        </div>
      </div>
      <div className="w-1/1 mb-3">
        {props.data ? <MyAreaChart data={props.data.points} /> : null}
      </div>
    </BlurredContainerM3030>
  );
};

export default withErrorBoundary(History, { fallback: Fallback });
